let stripePromise = null;

export function loadStripe() {
    if (window.Stripe) return Promise.resolve(window.Stripe);
    if (!stripePromise) {
        stripePromise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://js.stripe.com/v3/';
            script.async = true;
            script.onload = () => resolve(window.Stripe);
            script.onerror = () => {
                stripePromise = null;
                reject(new Error('Stripe.js failed to load'));
            };
            document.head.appendChild(script);
        });
    }
    return stripePromise;
}
